import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { LoadingDirective } from "@everbright/promotions";
import { configureValidation } from "../validation";
import {
    ValFormInput,
    ValSummary,
    Navbar,
    EnvironmentBanner,
    AjaxFileUpload,
    GridEditButton,
    GridDeleteButton,
    GridCurrencyColumn,
    DashboardGrid,
    GridPercentageColumn,
    DashboardGridCampaignCodeColumn,
    DashboardGridModeToggle,
    DateViewSelector,
    AgGridPagination,
    LocaleRadioButtonGroup,
    OrderHistoryGrid,
    DateSearchForm,
    GridDateColumn,
    GridCheckboxColumn,
    KpiCards
} from "../components";
import {
    PromotionManagementGrid,
    PromotionLineItemGrid,
    PromotionLineItemModal,
    PromotionUpsellGrid,
    PromotionUpsellModal,
    PromotionUpsellGridImage,
    UpsellPreviewButton,
    UpsellPreviewModal,
    ClonePromotionModal,
    ClonePromotionButton,
    PromotionPreviewButton
} from "../components/promotionManagement";
import {
    UserManagementGrid,
    UserManagementEditButton,
    UserManagementDeleteButton
} from "../components/userManagement";
import { AgGridVue } from "ag-grid-vue";
import Editor from "@tinymce/tinymce-vue";
import { errorLog } from "../logging";
import { wholeNumber } from "../filters/wholeNumber";

export default function configureVue() {
    // Raygun error logging:
    Vue.config.errorHandler = errorLog.send;

    Vue.use(BootstrapVue);

    addFilters();
    addDirectives();
    addComponents();

    configureValidation();
}

function addFilters() {
    Vue.filter("currency", (val: number | null) => {
        if (!val && val !== 0) {
            return "";
        }

        const formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });

        return formatter.format(val);
    });

    Vue.filter("percentage", (val: number | null) => {
        if (!val && val !== 0) {
            return "";
        }

        return (val * 100).toFixed(2) + "%";
    });

    Vue.filter("wholeNumber", wholeNumber);
}

function addDirectives() {
    Vue.directive("loading", LoadingDirective);
}

function addComponents() {
    // vee-validate
    Vue.component("validation-provider", ValidationProvider);
    Vue.component("validation-observer", ValidationObserver);

    // https://vue-select.org/
    Vue.component("v-select", VueSelect);

    // Note: we need to explicitly register each component with the tag name so that the names are correct in a production/minified build
    Vue.component("val-form-input", ValFormInput);
    Vue.component("val-summary", ValSummary);
    Vue.component("navbar", Navbar);
    Vue.component("promotion-management-grid", PromotionManagementGrid);
    Vue.component("user-management-grid", UserManagementGrid);
    Vue.component("ag-grid-vue", AgGridVue);
    Vue.component("environment-banner", EnvironmentBanner);
    Vue.component("user-management-edit-button", UserManagementEditButton);
    Vue.component("user-management-delete-button", UserManagementDeleteButton);
    Vue.component("editor", Editor);
    Vue.component("ajax-file-upload", AjaxFileUpload);
    Vue.component("promotion-line-item-grid", PromotionLineItemGrid);
    Vue.component("promotion-line-item-modal", PromotionLineItemModal);
    Vue.component("promotion-upsell-grid", PromotionUpsellGrid);
    Vue.component("promotion-upsell-modal", PromotionUpsellModal);
    Vue.component("promotion-upsell-grid-image", PromotionUpsellGridImage);
    Vue.component("upsell-preview-button", UpsellPreviewButton);
    Vue.component("upsell-preview-modal", UpsellPreviewModal);
    Vue.component("clone-promotion-modal", ClonePromotionModal);
    Vue.component("clone-promotion-button", ClonePromotionButton);
    Vue.component("dashboard-grid", DashboardGrid);
    Vue.component("grid-percentage-column", GridPercentageColumn);
    Vue.component("promotion-preview-button", PromotionPreviewButton);
    Vue.component("locale-radio-button-group", LocaleRadioButtonGroup);
    Vue.component("kpi-cards", KpiCards);

    Vue.component("grid-edit-button", GridEditButton);
    Vue.component("grid-delete-button", GridDeleteButton);
    Vue.component("grid-currency-column", GridCurrencyColumn);
    Vue.component(
        "dashboard-grid-campaign-code-column",
        DashboardGridCampaignCodeColumn
    );
    Vue.component("dashboard-grid-mode-toggle", DashboardGridModeToggle);
    Vue.component("date-view-selector", DateViewSelector);
    Vue.component("ag-grid-pagination", AgGridPagination);
    Vue.component("order-history-grid", OrderHistoryGrid);
    Vue.component("date-search-form", DateSearchForm);
    Vue.component("grid-date-column", GridDateColumn);
    Vue.component("grid-checkbox-column", GridCheckboxColumn);
}
